import React from 'react';
import { Navigate } from 'react-router';

import { LoanOverview } from 'packages/loans/ui/LoanOverview';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';

const RouteBase = () => {
  return <LoanOverview />;
};

export const Route = () => {
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/loans" />;
      }}
    >
      <RouteBase />
    </RouteErrorBoundary>
  );
};
